angular.module('app.entity.audit')
    .factory('EntityMenuPluginAudit', ['AccountManager', function(AccountManager) {
        return {
            buildAccess: function(access) {
                access.audit = AccountManager.hasPermission('read audit trail');
            },
        };
    }]);
